import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./css/Testimonials.css";
import axios from "axios";
import { Testimonials_BASE_URL } from "../../configs/WebServiceUrl";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import userStore from "../../zustand/userStore";
const AVATAR_GROUPS = [
  {
    label: "Kids",
    emojis: [
      "🧒",
      "🧒🏻",
      "🧒🏼",
      "🧒🏽",
      "🧒🏾",
      "🧒🏿",
      "👦",
      "👦🏻",
      "👦🏼",
      "👦🏽",
      "👦🏾",
      "👦🏿",
      "👧",
      "👧🏻",
      "👧🏼",
      "👧🏽",
      "👧🏾",
      "👧🏿",
    ],
  },
  {
    label: "Adults",
    emojis: [
      "🧑",
      "🧑🏻",
      "🧑🏼",
      "🧑🏽",
      "🧑🏾",
      "🧑🏿",
      "👩",
      "👩🏻",
      "👩🏼",
      "👩🏽",
      "👩🏾",
      "👩🏿",
      "👨",
      "👨🏻",
      "👨🏼",
      "👨🏽",
      "👨🏾",
      "👨🏿",
    ],
  },
  {
    label: "Elders",
    emojis: [
      "🧓",
      "🧓🏻",
      "🧓🏼",
      "🧓🏽",
      "🧓🏾",
      "🧓🏿",
      "👵",
      "👵🏻",
      "👵🏼",
      "👵🏽",
      "👵🏾",
      "👵🏿",
      "👴",
      "👴🏻",
      "👴🏼",
      "👴🏽",
      "👴🏾",
      "👴🏿",
    ],
  },
  {
    label: "Roles",
    emojis: [
      "👳",
      "👳🏻",
      "👳🏼",
      "👳🏽",
      "👳🏾",
      "👳🏿",
      "👩‍🧕",
      "👳‍♀️",
      "👳‍♂️",
      "👮",
      "👮🏻",
      "👮🏼",
      "👮🏽",
      "👮🏾",
      "👮🏿",
      "👷",
      "👷🏻",
      "👷🏼",
      "👷🏽",
      "👷🏾",
      "👷🏿",
      "💂",
      "💂🏻",
      "💂🏼",
      "💂🏽",
      "💂🏾",
      "💂🏿",
      "🕵️",
      "🕵🏻",
      "🕵🏼",
      "🕵🏽",
      "🕵🏾",
      "🕵🏿",
    ],
  },
  {
    label: "Careers",
    emojis: [
      "👩‍⚕️",
      "👨‍⚕️",
      "👩‍🏫",
      "👨‍🏫",
      "👩‍💻",
      "👨‍💻",
      "👩‍🔧",
      "👨‍🔧",
      "👩‍🍳",
      "👨‍🍳",
      "👩‍🎓",
      "👨‍🎓",
      "👩‍🎤",
      "👨‍🎤",
      "👩‍⚖️",
      "👨‍⚖️",
      "🧑‍🎄",
      "👩‍🎄",
      "👨‍🎄",
      "🧑‍🚀",
      "👩‍🚀",
      "👨‍🚀",
      "🧑‍✈️",
      "👩‍✈️",
      "👨‍✈️",
    ],
  },
];

/* ------------------------------------------------------------------ */
/*  Avatar picker                                                      */
/* ------------------------------------------------------------------ */
const EmojiInput = ({ field, form, setForm }) => {
  const [showEmojis, setShowEmojis] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setShowEmojis(false);
      }
    };
    const handleEscape = (e) => {
      if (e.key === "Escape") setShowEmojis(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, []);

  const selected = form[field.key];

  return (
    <div className="avatar-picker" ref={wrapperRef}>
      <button
        type="button"
        className={`avatar-trigger ${selected ? "has-value" : ""}`}
        onClick={() => setShowEmojis((prev) => !prev)}
        aria-haspopup="true"
        aria-expanded={showEmojis}
      >
        <span className="avatar-trigger-emoji">{selected || "🙂"}</span>
        <span className="avatar-trigger-text">
          {selected ? "Change" : "Choose avatar"}
        </span>
        <i
          className={`bi ${showEmojis ? "bi-chevron-up" : "bi-chevron-down"}`}
        />
      </button>

      {showEmojis && (
        <div className="avatar-dropdown" role="listbox">
          {AVATAR_GROUPS.map((group) => (
            <div className="avatar-group" key={group.label}>
              <div className="avatar-group-label">{group.label}</div>
              <div className="avatar-grid">
                {group.emojis.map((emoji, index) => (
                  <button
                    type="button"
                    key={`${group.label}-${index}`}
                    className={`avatar-option ${selected === emoji ? "selected" : ""}`}
                    onClick={() => {
                      setForm({ ...form, [field.key]: emoji });
                      setShowEmojis(false);
                    }}
                    aria-label={`Select avatar ${emoji}`}
                  >
                    {emoji}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

/* ------------------------------------------------------------------ */
/*  Star rating — supports half-star increments.                       */
/*  1st click on a star -> half filled, 2nd click on the same star ->  */
/*  fully filled, 3rd click -> clears back to empty.                   */
/* ------------------------------------------------------------------ */
const StarRating = ({ value, onChange }) => {
  const rating = Number(value) || 0;

  const handleStarClick = (star) => {
    let next;

    if (rating < star - 0.5) {
      next = star - 0.5;
    } else if (rating < star) {
      next = star;
    } else {
      next = star - 1;
    }

    onChange(next);
  };

  return (
    <div className="star-rating" role="radiogroup" aria-label="Rating">
      {[1, 2, 3, 4, 5].map((star) => {
        const fillPercent =
          rating >= star ? 100 : rating >= star - 0.5 ? 50 : 0;

        return (
          <button
            type="button"
            key={star}
            role="radio"
            aria-checked={rating >= star}
            aria-label={`${star} star${star > 1 ? "s" : ""}`}
            className="rating-star"
            onClick={() => handleStarClick(star)}
          >
            <span className="star-bg">★</span>

            <span
              className="star-fill"
              style={{
                clipPath: `inset(0 ${100 - fillPercent}% 0 0)`,
              }}
            >
              ★
            </span>
          </button>
        );
      })}
    </div>
  );
};
/* ------------------------------------------------------------------ */
/*  Main dialog                                                        */
/*  Note: I added a footer with Cancel / Submit actions and a live     */
/*  character counter + basic required-field validation, since the     */
/*  original markup had the styling hooks for these but no actions —   */
/*  adjust the `onSubmit` prop name to match your handler if needed.   */
/* ------------------------------------------------------------------ */
const QUOTE_MAX_LENGTH = 400;

function TestimonialDialog({ form, setForm, resetPopup, onSubmit }) {
  const isValid =
    !!form.name?.trim() && !!form.org?.trim() && !!form.quote?.trim();

  const handleSubmit = () => {
    // Logs everything currently filled in the form.
    console.log("Testimonial submitted:", {
      name: form.name,
      org: form.org,
      tag: form.tag,
      rating: form.rating,
      avatar: form.avatar,
      quote: form.quote,
    });

    // Still calls your own save/submit handler if one was passed in.
    onSubmit?.(form);
  };

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      onClose={() => setForm((prev) => ({ ...prev, showPopUp: false }))}
      open={form.showPopUp}
    >
      <style>
        {`
        :root {
          --td-navy: #16233f;
          --td-navy-soft: #405077;
          --td-gold: #e0a13a;
          --td-gold-soft: #fdf0da;
          --td-bg: #ffffff;
          --td-bg-muted: #f6f7fa;
          --td-border: #e2e5ec;
          --td-text: #1c2434;
          --td-text-muted: #6b7280;
          --td-danger: #d64545;
          --td-radius: 12px;
          --td-header-bg-start: #eef2ff;
          --td-header-bg-end: #f5f0fb;
          --td-primary: #5b7fe0;
          --td-primary-hover: #4f6fcb;
        }
 
        .testimonial-form {
          width: 100%;
          font-family: "Segoe UI", Roboto, -apple-system, BlinkMacSystemFont, sans-serif;
          color: var(--td-text);
        }
 
        /* Header */
        .testimonial-dialog-title {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          gap: 16px;
          padding: 22px 28px;
          background: linear-gradient(135deg, var(--td-header-bg-start) 0%, var(--td-header-bg-end) 100%);
          color: var(--td-navy);
        }
 
        .testimonial-title-group {
          display: flex;
          align-items: center;
          gap: 14px;
        }
 
        .testimonial-badge {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 42px;
          height: 42px;
          min-width: 42px;
          border-radius: 10px;
          background: #fff;
          box-shadow: 0 2px 6px rgba(22, 35, 63, 0.1);
          font-size: 20px;
        }
 
        .testimonial-title {
          font-size: clamp(17px, 2vw, 20px);
          font-weight: 700;
          letter-spacing: 0.1px;
        }
 
        .testimonial-subtitle {
          font-size: 13px;
          color: var(--td-navy-soft);
          margin-top: 3px;
        }
 
        .testimonial-close {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 34px;
          height: 34px;
          border: none;
          border-radius: 50%;
          cursor: pointer;
          color: var(--td-navy-soft);
          background: rgba(22, 35, 63, 0.06);
          font-size: 20px;
          transition: background 0.15s ease;
          flex-shrink: 0;
        }
 
        .testimonial-close:hover {
          background: rgba(22, 35, 63, 0.12);
        }
 
        /* Body */
        .testimonial-body {
          padding: 26px 28px 8px;
          background: var(--td-bg-muted);
        }
 
        .testimonial-row {
          display: grid;
          grid-template-columns: 1fr 2fr;
          gap: 18px;
          margin-bottom: 20px;
        }
 
        .testimonial-row.details-row {
          grid-template-columns: 2fr 1fr 1fr;
          align-items: start;
        }
 
        .testimonial-field {
          width: 100%;
          margin-bottom: 20px;
        }
 
        .testimonial-label {
          display: flex;
          align-items: baseline;
          gap: 4px;
          margin-bottom: 7px;
          font-size: 13.5px;
          font-weight: 600;
          color: var(--td-navy);
        }
 
        .required {
          color: var(--td-danger);
        }
 
        /* Inputs */
        .testimonial-form .form-control {
          width: 100%;
          min-height: 44px;
          box-sizing: border-box;
          background: #fff;
          border: 1.5px solid var(--td-border);
          border-radius: var(--td-radius);
          padding: 10px 13px;
          font-size: 14px;
          color: var(--td-text);
          transition: border-color 0.15s ease, box-shadow 0.15s ease;
        }
 
        .testimonial-form .form-control:focus {
          border-color: var(--td-navy-soft);
          box-shadow: 0 0 0 3px rgba(64, 80, 119, 0.14);
          outline: none;
        }
 
        .testimonial-form .form-control:disabled {
          background: #f1f2f5;
          color: var(--td-text-muted);
          cursor: not-allowed;
        }
 
        .testimonial-form .form-control::placeholder {
          color: #a3a9b7;
        }
 
        /* Stars */
      /* Star Rating */
.star-rating {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
  width: 100%;
  min-height: 44px;
  box-sizing: border-box;
}

.rating-star {
  position: relative;
  display: block;
  flex: 0 0 32px;
  width: 32px;
  height: 32px;
  min-width: 32px;
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
  font-size: 28px;
  line-height: 32px;
  cursor: pointer;
  transition: transform 0.12s ease;
}

.rating-star:hover {
  transform: scale(1.1);
}

.rating-star:focus-visible {
  outline: 2px solid var(--td-navy-soft);
  outline-offset: 2px;
  border-radius: 4px;
}

.star-bg,
.star-fill {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  line-height: 32px;
  white-space: nowrap;
  pointer-events: none;
}

.star-bg {
  color: #d9dee3;
}

.star-fill {
  color: var(--td-gold);
}
@media (max-width: 700px) {
  .testimonial-form,
  .testimonial-body,
  .testimonial-row,
  .testimonial-row.details-row {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }

  .testimonial-row > div {
    min-width: 0;
    width: 100%;
  }
}
 
        /* Avatar picker */
        .avatar-picker {
          position: relative;
          width: 100%;
        }
 
        .avatar-trigger {
          width: 100%;
          height: 44px;
          display: flex;
          align-items: center;
          gap: 8px;
          box-sizing: border-box;
          border: 1.5px solid var(--td-border);
          border-radius: var(--td-radius);
          background: #fff;
          padding: 0 12px;
          cursor: pointer;
          font-size: 13px;
          color: var(--td-text-muted);
          transition: border-color 0.15s ease;
        }
 
        .avatar-trigger:hover,
        .avatar-trigger:focus-visible {
          border-color: var(--td-navy-soft);
          outline: none;
        }
 
        .avatar-trigger.has-value {
          color: var(--td-text);
        }
 
        .avatar-trigger-emoji {
          font-size: 19px;
          line-height: 1;
        }
 
        .avatar-trigger-text {
          flex: 1;
          text-align: left;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
 
        .avatar-dropdown {
          position: absolute;
          top: calc(100% + 8px);
          right: 0;
          width: 260px;
          max-width: 90vw;
          max-height: 280px;
          overflow-y: auto;
          background: #fff;
          border: 1px solid var(--td-border);
          border-radius: var(--td-radius);
          box-shadow: 0 10px 30px rgba(22, 35, 63, 0.18);
          padding: 12px;
          z-index: 9999;
        }
 
        .avatar-group + .avatar-group {
          margin-top: 10px;
        }
 
        .avatar-group-label {
          font-size: 11px;
          font-weight: 700;
          color: var(--td-text-muted);
          margin-bottom: 6px;
          padding-left: 2px;
        }
 
        .avatar-grid {
          display: grid;
          grid-template-columns: repeat(6, 1fr);
          gap: 4px;
        }
 
        .avatar-option {
          width: 100%;
          aspect-ratio: 1;
          border: none;
          background: transparent;
          border-radius: 7px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          line-height: 1;
        }
 
        .avatar-option:hover {
          background: var(--td-bg-muted);
        }
 
        .avatar-option.selected {
          background: var(--td-gold-soft);
          box-shadow: inset 0 0 0 1.5px var(--td-gold);
        }
 
        /* Quote */
        .testimonial-textarea {
          resize: vertical;
          min-height: 110px !important;
        }
 
        .quote-footer {
          display: flex;
          justify-content: flex-end;
          margin-top: 5px;
          font-size: 11.5px;
          color: var(--td-text-muted);
        }
 
        .quote-footer.near-limit {
          color: var(--td-gold);
          font-weight: 600;
        }
 
        .quote-footer.at-limit {
          color: var(--td-danger);
          font-weight: 600;
        }
 
        /* Actions */
        .testimonial-actions {
          padding: 16px 28px 22px;
          background: var(--td-bg-muted);
          gap: 10px !important;
        }
 
        .btn-cancel,
        .btn-submit {
          height: 42px;
          padding: 0 20px;
          border-radius: 9px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: filter 0.15s ease, transform 0.05s ease;
        }
 
        .btn-cancel {
          border: 1.5px solid var(--td-border);
          background: #fff;
          color: var(--td-text-muted);
        }
 
        .btn-cancel:hover {
          background: #f1f2f5;
        }
 
        .btn-submit {
          border: none;
          background: var(--td-primary);
          color: #fff;
        }
 
        .btn-submit:hover:not(:disabled) {
          background: var(--td-primary-hover);
        }
 
        .btn-submit:active:not(:disabled) {
          transform: translateY(1px);
        }
 
        .btn-submit:disabled {
          background: #b7bccb;
          cursor: not-allowed;
        }
 
        /* Mobile */
        @media (max-width: 700px) {
          .testimonial-dialog-title {
            padding: 18px 18px;
          }
 
          .testimonial-body {
            padding: 20px 18px 4px;
          }
 
          .testimonial-row,
          .testimonial-row.details-row {
            grid-template-columns: 1fr;
            gap: 16px;
          }
 
          .avatar-dropdown {
            right: auto;
            left: 0;
          }
 
          .testimonial-actions {
            padding: 14px 18px 18px;
            flex-direction: column-reverse;
          }
 
          .btn-cancel,
          .btn-submit {
            width: 100%;
          }
        }
      `}
      </style>

      {/* Header */}
      <DialogTitle className="testimonial-dialog-title">
        <div className="testimonial-title-group">
          <div className="testimonial-badge" aria-hidden="true">
            🎓
          </div>
          <div>
            <div className="testimonial-title">Add Student Testimonial</div>
            <div className="testimonial-subtitle">
              Share your achievement and experience
            </div>
          </div>
        </div>

        <button
          type="button"
          className="testimonial-close"
          onClick={resetPopup}
          title="Close"
          aria-label="Close dialog"
        >
          <i className="bi bi-x"></i>
        </button>
      </DialogTitle>

      <DialogContent className="testimonial-body" style={{ padding: 0 }}>
        <div className="testimonial-form">
          <div className="testimonial-body">
            {/* Row 1 - Name + School */}
            <div className="testimonial-row">
              <div>
                <label className="testimonial-label">
                  Student Name <span className="required">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter student name"
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  disabled={!!form.name}
                />
              </div>

              <div>
                <label className="testimonial-label">
                  School Name <span className="required">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter school name"
                  value={form.org}
                  onChange={(e) => setForm({ ...form, org: e.target.value })}
                  disabled={!!form.org}
                />
              </div>
            </div>

            {/* Row 2 - Achievement + Rating + Avatar */}
            <div className="testimonial-row details-row">
              <div>
                <label className="testimonial-label">
                  Achievement / Position
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="e.g. 1st Prize"
                  value={form.tag}
                  onChange={(e) => setForm({ ...form, tag: e.target.value })}
                />
              </div>

              <div>
                <label className="testimonial-label">Rating</label>
                <StarRating
                  value={form.rating}
                  onChange={(star) => setForm({ ...form, rating: star })}
                />
              </div>

              <div>
                <label className="testimonial-label">Avatar</label>
                <EmojiInput
                  field={{ key: "avatar", label: "Avatar Emoji", emoji: true }}
                  form={form}
                  setForm={setForm}
                />
              </div>
            </div>

            {/* Row 3 - Quote */}
            <div className="testimonial-field">
              <label className="testimonial-label">
                Content / Quote <span className="required">*</span>
              </label>
              <textarea
                rows={4}
                maxLength={QUOTE_MAX_LENGTH}
                className="form-control testimonial-textarea"
                placeholder="Enter the student's testimonial or feedback..."
                value={form.quote}
                onChange={(e) => setForm({ ...form, quote: e.target.value })}
              />
              <div
                className={`quote-footer ${
                  QUOTE_MAX_LENGTH - (form.quote?.length || 0) <= 40
                    ? QUOTE_MAX_LENGTH - (form.quote?.length || 0) <= 0
                      ? "at-limit"
                      : "near-limit"
                    : ""
                }`}
              >
                {form.quote?.length || 0} / {QUOTE_MAX_LENGTH}
              </div>
            </div>
          </div>
        </div>
      </DialogContent>

      <DialogActions className="testimonial-actions">
        <button type="button" className="btn-cancel" onClick={resetPopup}>
          Cancel
        </button>
        <button
          type="button"
          className="btn-submit"
          disabled={!isValid}
          onClick={handleSubmit}
        >
          Submit Testimonial
        </button>
      </DialogActions>
    </Dialog>
  );
}
const stats = [
  { value: "10,000+", label: "Happy Students" },
  { value: "500+", label: "Registered Schools" },
  { value: "₹50,000+", label: "Prizes Distributed" },
  { value: "1,000+", label: "Success Stories" },
];

const featureBoxes = [
  {
    title: "Quiz Champions",
    desc: "Students who have excelled in competitive quizzes and won significant prizes",
    icon: "🏆",
    bg: "linear-gradient(90deg,#f3f6ff,#eef7ff)",
  },
  {
    title: "Academic Excellence",
    desc: "Students showing remarkable improvement in their academic performance",
    icon: "🎓",
    bg: "linear-gradient(90deg,#eefaf2,#f5fff6)",
  },
  {
    title: "School Success",
    desc: "Educational institutions achieving outstanding results with our platform",
    icon: "🏫",
    bg: "linear-gradient(90deg,#fff6f0,#fff6f0)",
  },
];

const Testimonials = () => {
  const userData = userStore((state) => state.user);
  const TestimonialsList = `${Testimonials_BASE_URL}/api/school/syllabus/testmonials/published`;
  const [testimonialItems, setTestimonials] = useState([]);
  const [form, setForm] = useState({
    name: "",
    role: "",
    org: "",
    rating: "",
    quote: "",
    tag: "",
    avatar: "",
    mode: "",
    id: "",
    showPopUp: false,
    testimonialsList: [],
  });

  useEffect(() => {
    axios
      // .get(`${BASE_URL}/homepage/testimonials`)
      .get(TestimonialsList)
      .then((res) => setTestimonials(res.data?.data || []))
      .catch((err) => console.error("Error fetching testimonials:", err));
  }, []);
  const resetPopup = () => {
    setForm((prev) => ({ ...prev, showPopUp: false, mode: "" }));
  };
  return (
    <div className="testimonials-page">
      <header className="tm-header bg-light py-5">
        <div className="tm-container text-center">
          <div className="header-title">
            <h1>Student Testimonials</h1>
            <p>
              Hear from our amazing students, teachers, and schools about their
              DocMaster Quiz experience
            </p>
          </div>

          <div className="stats-row">
            {stats.map((s, idx) => (
              <div key={idx} className="stat-item">
                <div className="stat-value">{s.value}</div>
                <div className="stat-label">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </header>
      <button
        title="Add new testimonial"
        style={{
          float: "right",
          backgroundColor: "#0d6efd",
          color: "#fff",
          border: "none",
          borderRadius: "6px",
          padding: "8px 18px",
          fontSize: "14px",
          fontWeight: "500",
          cursor: "pointer",
          boxShadow: "0 2px 5px rgba(0, 0, 0, 0.15)",
          marginTop: "1%",
        }}
        onClick={() =>
          setForm((prev) => ({
            ...prev,
            showPopUp: true,
            name: userData?.admin_name || "",
            role: userData?.role || "",
            org: userData?.school_name || "",
          }))
        }
      >
        + Add
      </button>
      <main className="tm-container tm-main">
        <section className="testimonials-grid">
          {testimonialItems?.length > 0 &&
            testimonialItems?.map((t, i) => (
              <article key={i} className="testimonial-card">
                <div className="tc-top">
                  <div className="tc-avatar">{t.avatar}</div>
                  <div className="tc-person">
                    <div className="tc-name">{t.name}</div>
                    <div className="tc-sub">{t.role}</div>
                    <div className="tc-org">{t.org}</div>
                  </div>
                  <div className="tc-rating">
                    {Array.from({ length: t.rating }).map((_, r) => (
                      <span key={r} className="star">
                        ★
                      </span>
                    ))}
                  </div>
                </div>

                <div className="tc-quote">"{t.quote}"</div>

                <div className="tc-badge">{t.tag}</div>
              </article>
            ))}
        </section>

        <section className="features-row">
          {featureBoxes.map((f, idx) => (
            <div className="feature-box" key={idx} style={{ background: f.bg }}>
              <div className="feature-icon">{f.icon}</div>
              <h4 className="feature-title">{f.title}</h4>
              <p className="feature-desc">{f.desc}</p>
            </div>
          ))}
        </section>

        <section className="cta-box">
          <h3>Join Our Success Community</h3>
          <p>
            Be part of thousands of students achieving academic excellence
            through interactive learning
          </p>
          <div className="cta-actions">
            <button className="btn-primary large">Start Your Journey</button>
            <button className="btn-outline large">View Success Stories</button>
          </div>
        </section>
      </main>
      {form.showPopUp && (
        <TestimonialDialog
          form={form}
          setForm={setForm}
          resetPopup={resetPopup}
          onSubmit={() => console.log("hi")}
        />
      )}
    </div>
  );
};

export default Testimonials;
// {/* { key: "role", label: "Designation / Role" }, */}
